import React from 'react';
import { XMarkIcon, DocumentTextIcon } from '@heroicons/react/24/outline';

/**
 * Componente Modal ultra-minimalista para el Aviso de Privacidad
 * Aparece en la parte superior después de 10 segundos o al intentar enviar formulario
 */
const PrivacyModal = ({ isOpen, onAccept, onReject, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50">
      {/* Backdrop sutil */}
      <div className="fixed inset-0 bg-black bg-opacity-30"></div>
      
      {/* Modal responsivo y pequeño */}
      <div className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[90%] max-w-sm sm:max-w-md lg:max-w-lg px-4">
        <div className="bg-white rounded-lg shadow-xl border border-gray-200 max-h-[80vh] flex flex-col">
          {/* Header compacto */}
          <div className="flex items-center justify-between p-3 sm:p-4 border-b border-gray-100 flex-shrink-0">
            <h3 className="text-sm sm:text-base font-semibold text-gray-800 font-serif">
              Aviso de Privacidad
            </h3>
            <button
              onClick={onClose}
              className="p-1 hover:bg-gray-100 rounded-full transition-colors duration-200"
              aria-label="Cerrar"
            >
              <XMarkIcon className="h-4 w-4 sm:h-5 sm:w-5 text-gray-500" />
            </button>
          </div>

          {/* Content con scrollbar */}
          <div className="p-3 sm:p-4 overflow-y-auto flex-1" style={{ maxHeight: '50vh' }}>
            <div className="space-y-3 sm:space-y-4">
              <p className="text-xs sm:text-sm text-gray-700 leading-relaxed font-sans">
                <strong>Responsable:</strong> Cardiología del Norte S.A. de C.V., Priv. José Marroquín Leal 221 Nte, Col. Centro, C.P. 64000, Monterrey, N.L., México.
              </p>
              
              <p className="text-xs sm:text-sm text-gray-700 leading-relaxed font-sans">
                <strong>Datos tratados:</strong> Identificación, contacto, salud (sensibles), facturación y pago.
              </p>
              
              <p className="text-xs sm:text-sm text-gray-700 leading-relaxed font-sans">
                <strong>Finalidades:</strong> Brindar servicios médicos, gestionar pagos y cumplir obligaciones legales.
              </p>
              
              <p className="text-xs sm:text-sm text-gray-700 leading-relaxed font-sans">
                <strong>Finalidades secundarias:</strong> recordatorios, encuestas y promociones (puede oponerse).
              </p>
              
              <p className="text-xs sm:text-sm text-gray-700 leading-relaxed font-sans">
                <strong>Derechos ARCO:</strong> Solicítelos en cardiologianorte221@outlook.com.
              </p>
              
              <p className="text-xs sm:text-sm text-gray-700 leading-relaxed font-sans">
                <strong>Transferencias:</strong> Autoridades y proveedores necesarios para la atención.
              </p>
              
              <p className="text-xs sm:text-sm text-gray-700 leading-relaxed font-sans">
                <strong>Cookies:</strong> Actualmente no utilizamos cookies ni tecnologías de rastreo.
              </p>
              
              <p className="text-xs sm:text-sm text-gray-700 leading-relaxed font-sans">
                <strong>Cambios y versión vigente:</strong> consulte cardiologiadelnorte.com/aviso-de-privacidad.
              </p>
              
              <p className="text-xs sm:text-sm text-gray-700 leading-relaxed font-sans">
                <strong>Última actualización:</strong> 23/07/2025.
              </p>
            </div>

            <div className="mt-4 p-2 sm:p-3 bg-gray-50 rounded text-center">
              <span className="text-xs text-gray-500 font-sans">Documento completo:</span>
              <a
                href="/aviso_de_privacidad.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center ml-2 px-2 py-1 bg-gray-100 text-gray-600 rounded text-xs hover:bg-gray-200 transition-colors duration-200 font-sans"
              >
                <DocumentTextIcon className="h-3 w-3 mr-1" />
                PDF Completo
              </a>
            </div>
          </div>

          {/* Botones compactos */}
          <div className="flex gap-2 p-3 sm:p-4 bg-gray-50 border-t border-gray-100 flex-shrink-0">
            <button
              onClick={onReject}
              className="flex-1 px-3 py-2 border border-gray-300 text-gray-700 rounded text-xs sm:text-sm hover:bg-gray-100 transition-colors duration-200 font-medium font-sans"
            >
              Solo Ver
            </button>
            <button
              onClick={onAccept}
              className="flex-1 px-3 py-2 bg-primary text-white rounded text-xs sm:text-sm hover:bg-primary/90 transition-colors duration-200 font-medium font-sans"
            >
              Acepto
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyModal;
